let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4uc36")).then(() => parcelRequire('kLd68'));